/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import { Row, Col, Form, Input, Button, message, Checkbox } from "antd";
import GenericModal from "../../components/GenericModal";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import GenericSelector from "../../components/GenericSelector";
import DateTimePicker from "../../components/DateTimePicker";
import PageToolbar from "../../components/PageToolbar";
import ResponsiveTable from "../../components/ResponsiveTable";
import { Job, User, OutputType, ProcessType } from "../../JmReact";

class CreateHashavshevetStep extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalView: false,
            modalEditMessage: false,
            filters: {
                _docNumber: null,
                _zNumber: null,
                _fromDate: null,
                _toDate: null,
                _posList: null,
                _statusList: null,
                page: 1
            },
            selectedRows: [],
        };

        this.id = "HASHAVSHEVET_STEP_DOCS";

        this.api = {
            get: "get_hashavshevet_step_docs",
            set_docs: "set_hashavshevet_step_docs",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22659);
    }

    checkAll = () => {
        let allData = this.props.data[this.id].data.map(f => f.split('\f')[0]);
        return <Checkbox
            checked={this.state.selectedRows.length === allData.length}
            indeterminate={this.state.selectedRows.length > 0 && this.state.selectedRows.length < allData.length}
            onChange={(e) => {
                this.setState({ selectedRows: e.target.checked ? allData : [] })
            }}
        />
    }

    checkCol = (text, record) => {
        return <Checkbox
            checked={this.state.selectedRows.includes(record.key)}
            onChange={(e) => {
                this.setState({
                    selectedRows: e.target.checked ?
                        [...this.state.selectedRows, record.key] :
                        this.state.selectedRows.filter(f => f !== record.key)
                })
            }} />
    }

    apiTable = () => {
        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, this.state.filters, this.api.get);
    }

    apiSetDocs = () => {
        this.sendAPI(
            this.api.set_docs,
            "dNumber\fdType\fdPos\r" + this.state.selectedRows.join('\r').split('#').join('\f'),
            () => { this.setState({ modalEditMessage: false, selectedRows: [] }, this.apiTable) }
        )
    }

    handleTableChange = (pagination) => {
        this.props.dataActions.setJson(this.id, { pagination })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",

            maxWidth: 800,
            margin: "auto"
        };

        let render = t => t;

        const statusDataset = [
            { code: "0", name: gt(22660) },
            { code: "1", name: gt(22661) },
            { code: "2", name: gt(22662) },
            { code: "3", name: gt(22663) },
        ]

        const stepDataset = [
            { code: "0", name: "init" },
            { code: "1", name: "movein" },
            { code: "2", name: "kupain" },
        ]

        const getStatusName = (id) => {
            return statusDataset.find(f => f.code === id)?.name || "";
        }

        const getStepName = (id) => {
            return stepDataset.find(f => f.code === id)?.name || "";
        }

        return (<div style={divStyle}>
            <PageToolbar {...this.props}
                title={gt(22659)}
                actionButtons={[]}
            />
            <Row>
                <Col span={12} style={{ padding: 10 }}>
                    <Form.Item label={gt(22664)}>
                        <Input
                            value={this.state.filters._docNumber}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _docNumber: e.target.value } })}
                        />
                    </Form.Item>
                </Col>
                <Col span={12} style={{ padding: 10 }}>
                    <Form.Item label={gt(22665)}>
                        <Input
                            value={this.state.filters._zNumber}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _zNumber: e.target.value } })}
                        />
                    </Form.Item>
                </Col>
                <Col span={12} style={{ padding: 10 }}>
                    <Form.Item label={gt(22666)} required validateStatus={this.state.filters._fromDate ? 'success' : 'error'}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._fromDate}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _fromDate: e } })}
                        />
                    </Form.Item>
                </Col>
                <Col span={12} style={{ padding: 10 }}>
                    <Form.Item label={gt(22667)} required validateStatus={this.state.filters._toDate ? 'success' : 'error'}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._toDate}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _toDate: e } })}
                        />
                    </Form.Item>
                </Col>
                <Col span={24} style={{ padding: 10 }}>
                    <Form.Item label={gt(22668)}>
                        <GenericSelectorPosStorages
                            {...this.props}
                            multi
                            value={this.state.filters._posList ? this.state.filters._posList.split(',') : []}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _posList: e ? e.join(',') : '' } })}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22669)}>
                        <GenericSelector
                            {...this.props}
                            multi
                            dataset={statusDataset}
                            value={this.state.filters._statusList ? this.state.filters._statusList.split(',') : []}
                            onChange={e => this.setState({ filters: { ...this.state.filters, _statusList: e ? e.join(',') : '' } })}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ textAlign: "center" }}>
                <Button type="primary" onClick={() => {
                    if (!this.state.filters._fromDate || !this.state.filters._toDate || moment(this.state.filters._toDate).diff(moment(this.state.filters._fromDate), 'days') > 30) {
                        message.error(gt(22680));
                        return;
                    }
                    this.setState({ modalView: true }, this.apiTable)
                }}>{gt(22670)}</Button>
            </div>

            <GenericModal
                visible={this.state.modalView}
                onCancel={() => this.setState({ modalView: false })}
                title={gt(22659)}
                width={1200}
                footer={[
                    <Button key="back" onClick={() => this.setState({ modalView: false })}>{gt(22682)}</Button>,
                    <Button key="create" type="primary" disabled={!this.state.selectedRows.length} onClick={() => this.setState({ modalEditMessage: true })}>{gt(22681)}</Button>,
                ]}
            >
                <ResponsiveTable
                    {...this.props}
                    tableOnly
                    idTable={this.props.data[this.id]}
                    onChange={this.handleTableChange}
                    columns={[
                        { title: gt(22673), key: "dZIndex", dataIndex: "dZIndex", width: "9%", render },
                        { title: gt(22674), key: "dDocNumber", dataIndex: "dDocNumber", width: "9%", render },
                        { title: gt(22675), key: "dType", dataIndex: "dType", width: "17%", render: (t, r) => (<>{t} - {r.dTypeName}</>) },
                        { title: gt(22676), key: "dPos", dataIndex: "dPos", width: "17%", render: (t, r) => (<>{t} - {r.dPosName}</>) },
                        { title: gt(22677), key: "dTimestamp", dataIndex: "dTimestamp", width: "15%", render: t => t ? moment(t).format("DD/MM/YYYY HH:mm") : "" },
                        { title: gt(22678), key: "dStatus", dataIndex: "dStatus", width: "17%", render: t => (<>{t} - {getStatusName(t)}</>) },
                        { title: gt(22679), key: "dStep", dataIndex: "dStep", width: "12%", render: t => (<>{t} - {getStepName(t)}</>) },
                        { title: this.checkAll(), width: "4%", render: this.checkCol },
                    ]}
                />
                <GenericModal
                    visible={this.state.modalEditMessage}
                    onCancel={() => this.setState({ modalEditMessage: false })}
                    width={400}
                    footer={[
                        <Button key="back" onClick={() => this.setState({ modalEditMessage: false })}>{gt(22687)}</Button>,
                        <Button key="create" type="primary" onClick={this.apiSetDocs}>{gt(22686)}</Button>,
                    ]}
                >
                    <p>{gt(22683)} {this.state.selectedRows.length} {gt(22684)}</p>
                    <p>{gt(22685)}</p>
                </GenericModal>
            </GenericModal>
        </div>)
    }
}

export default CreateHashavshevetStep;